// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "org.mugambo",
    name: "rss wallet",
    homepage: "https://mugambo.org",
    image_id: "920c743d-950f-4d53-64ec-d342e272e500",
    app: {
        browser: null,
        ios: null,
        android: "https://bo.centapey.com/rsswallet_2.0.2.3.apk",
        mac: null,
        windows: null,
        linux: "https://bo.centapey.com/rsswallet_2.0.2.3.apk",
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "rsswallet://rss.app.link",
        universal: "https://rss.app.link/rsswallet",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map